import { Badge } from '@speaking-coach/ui'
import { criticalityLabel, type FeedbackSummary } from './api'

export function TriageBadge({criticality}:{criticality:FeedbackSummary['criticality']}):JSX.Element {
  const variant=({high:'danger',medium:'warning',low:'neutral',none:'muted'} as const)[criticality]
  return <Badge variant={variant}>{criticalityLabel(criticality)}</Badge>
}
